var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabels18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_222",
    "data-name": "Grupo 222",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.397,
    height: 89,
    viewBox: "0 0 65.397 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M7.07,0H58.327A6.844,6.844,0,0,1,65.4,6.593V82.407A6.844,6.844,0,0,1,58.327,89H7.07A6.844,6.844,0,0,1,0,82.407V6.593A6.844,6.844,0,0,1,7.07,0Z",
    fill: "#2c3d71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_135",
    "data-name": "Rect\\xE1ngulo 135",
    width: 25,
    height: 17,
    transform: "translate(0.082 58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147",
    "data-name": "Rect\\xE1ngulo 147",
    width: 25,
    height: 17,
    transform: "translate(27.082 58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150",
    "data-name": "Rect\\xE1ngulo 150",
    width: 25,
    height: 17,
    transform: "translate(0.082 39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_151",
    "data-name": "Rect\\xE1ngulo 151",
    width: 25,
    height: 17,
    transform: "translate(27.082 39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_152",
    "data-name": "Rect\\xE1ngulo 152",
    width: 25,
    height: 16,
    transform: "translate(0.082 20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_153",
    "data-name": "Rect\\xE1ngulo 153",
    width: 25,
    height: 16,
    transform: "translate(27.082 20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_154",
    "data-name": "Rect\\xE1ngulo 154",
    width: 25,
    height: 17,
    transform: "translate(0.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_155",
    "data-name": "Rect\\xE1ngulo 155",
    width: 25,
    height: 17,
    transform: "translate(27.082)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabels18);
export default __webpack_public_path__ + "static/media/labels1-8.4f5dde4f.svg";
export { ForwardRef as ReactComponent };